import * as React from 'react';

function UserHeader(){
    const cl = "app-layout-header";
    return(
        <>
            <div className={`${cl}`}>
                <div className={`${cl}__wrapper`}>
                    <div className={`${cl}__left`}>
                        <img className="app-logo" src="/images/vibhohcm-logo.svg"/>
                    </div>
                </div>
            </div>
        </>
    )
}
export default UserHeader;
